import { z } from 'zod';

// Helper to check for common XSS patterns
const xssPattern = /<[^>]*>?/gm;

export const createLoanApplicationSchema = (maxAmount: number = Infinity) => z.object({
  phoneNumber: z
    .string()
    .min(12, 'Telefon numarası en az 10 karakter olmalıdır.')
    .max(12, 'Telefon numarası 10 karakter olmalıdır.')
    .regex(/^905[0-9*]{9}$/, 'Geçerli bir telefon numarası giriniz (Örn: +90 5XX XXX XX XX).')
    .refine((val) => !xssPattern.test(val), {
      message: 'Geçersiz karakterler tespit edildi.',
    }),
  birthDate: z
    .string()
    .min(1, 'Doğum tarihi zorunludur.')
    .refine((val) => {
      const dateRegex = /^((0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4})$/;
      return val.includes('*') || dateRegex.test(val);
    }, 'Geçersiz tarih formatı. Lütfen GG-AA-YYYY şeklinde giriniz.')
    .refine((val) => !xssPattern.test(val), {
      message: 'Geçersiz karakterler tespit edildi.',
    }),
  requestedAmount: z
    .string()
    .min(1, 'Kredi tutarı zorunludur.')
    .refine((val) => !xssPattern.test(val), {
      message: 'Geçersiz karakterler tespit edildi.',
    })
    .refine((val) => {
        // "1.500,50" -> "1500.50"
        const numStr = val.replace(/\./g, '').replace(/,/g, '.');
        const num = parseFloat(numStr);
        return !isNaN(num) && num <= maxAmount;
    }, {
        message: `Maksimum tutar ${maxAmount.toLocaleString('tr-TR')} TL olmalıdır.`
    }),
  applicationReason: z
    .string()
    .min(2, 'Başvuru sebebi çok kısa.')
    .max(500, 'Başvuru sebebi çok uzun.')
    .refine((val) => !xssPattern.test(val), {
      message: 'Geçersiz karakterler tespit edildi.',
    }),
  consents: z.array(
    z.object({
      consentId: z.string(),
      documentUrl: z.string(),
      mandatory: z.boolean(),
      isApproved: z.boolean(),
    })
  ).superRefine((consents, ctx) => {
    consents.forEach((consent, index) => {
        if (consent.mandatory && !consent.isApproved) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Bu alanı onaylamanız gerekmektedir.`,
                path: [index, 'isApproved'],
            });
        }
    });
  }),
});

export type LoanApplicationFormValues = z.infer<ReturnType<typeof createLoanApplicationSchema>>;
